<template>
    <div class="container-fluid">
        <div class="row project-cards">
            <div class="col-sm-12">
                <button :class="'btn btn-sm '+(is_active ? 'btn-danger' : 'btn-success')"  style="float: right; margin-bottom: 30px; margin-right: 10px;" type="button" @click="changeType(!is_active)">Empleados {{ is_active ? 'Inactivos' : 'Activos' }}</button>
                <h3>Empleados {{ is_active ? 'Activos' : 'Inactivos' }}</h3>
            </div>
            
            <div class="col-sm-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-3">
                                <input class="form-control" placeholder="Buscar..." v-model="search" style="height: 33px; font-size: 12px;"/>
                            </div>
                            <div class="col-md-2">

                            </div>
                            <div class="col-md-3" style="text-align: right;">
                                <select class="form-select" v-model="employerSelect" style="float: right;" @change="changeFilters">
                                    <option v-for="(employer, index) in employers" :key="index" :value="employer.id">{{ employer.name }}</option>
                                </select>
                            </div>
                            <div class="col-md-4">
                                <button class="btn btn-primary btn-sm" style="float: right; margin-bottom: 30px;" type="button" @click="loadEmployer(employerSelect)" data-bs-toggle="modal" data-bs-target=".employee-modal">Nuevo Empleado</button>
                                <button class="btn btn-info btn-sm" style="float: right; margin-bottom: 30px; margin-right: 10px;" type="button" data-bs-toggle="modal" data-bs-target=".employee-import-modal">Importar Empleados</button>
                                <button class="btn btn-success btn-sm" style="float: right; margin-bottom: 30px; margin-right: 10px;" type="button" @click="exportEmployees">Exportar</button>
                            </div>
                            <div class="col-xl-4 col-sm-6 col-xxl-3 col-ed-4 box-col-4" v-for="(employee, index) in filteredEmployees" :key="index">
                                <router-link :to="'/panel/'+employee.id+'/employee'">
                                <div class="card social-profile">
                                    <div class="card-body">
                                        <div class="social-img-wrap">
                                            <div class="social-img"><img src="@/assets/images/user.png" alt="profile"></div>
                                            <div class="edit-icon">
                                                <svg>
                                                    <use href="@/assets/svg/icon-sprite.svg#profile-check"></use>
                                                </svg>
                                            </div>
                                        </div>
                                        <div class="social-details">
                                            <h5 class="mb-1" style="font-size: 12px;">{{ employee.name }}</h5>
                                            <span class="f-light">{{ employee.job_position ? employee.job_position : '&nbsp;'}}</span>
                                            <ul class="social-follow">
                                                <li>
                                                    <h5 class="mb-0" style="font-size: 12px;">{{ $formatCurrency(employee.daily_salary+"") }}</h5><span class="f-light" style="font-size: 12px;">S.D</span>
                                                </li>
                                                <li>
                                                    <h5 class="mb-0" style="font-size: 12px;">{{ $formatCurrency((employee.integral_daily_salary)+"") }}</h5><span class="f-light" style="font-size: 12px;">S.D.I</span>
                                                </li>
                                                <li>
                                                    <h5 class="mb-0" style="font-size: 12px;">{{ $formatCurrency(employee.final_wage+"") }}</h5><span class="f-light" style="font-size: 12px;">Sueldo</span>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="ribbon ribbon-bookmark ribbon-right ribbon-danger" v-if="!employee.is_active">BAJA:  {{ $formatDate(employee.final_date) }}</div>
                                    </div>
                                </div>
                                </router-link>
                            </div>
                        </div>
                    </div>

                    <div class="modal fade employee-modal" tabindex="-1" role="dialog" aria-labelledby="employeeModalLabel"aria-hidden="true">
                        <EmployeModal ref="employeeModal" />
                    </div>
                    <div class="modal fade employee-import-modal" tabindex="-1" role="dialog" aria-labelledby="employeeModalLabel"aria-hidden="true">
                        <EmployeImportModal ref="employeeImportModal" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import getImage from "@/mixins/getImage"

import EmployeModal from "@/components/tmkt/employees/employee_modal.vue"
import EmployeImportModal from "@/components/tmkt/employees/employees_import_modal.vue"

import ws from '@/services/employees'

export default {
    name: 'employees',
    components: {
        EmployeModal,
        EmployeImportModal
    },
    data(){
        return{
            employees: null,
            search: "",
            employers: null, 
            employerSelect: 0,
            lastEmployer: 0,
            is_active: 1
        }
    },
    mounted: async function() {
        let response2 = await ws.getEmployers(); 

        if(response2.type == "success"){
            this.employers = response2.data;

            this.employerSelect = this.employers[0].id;
        }

        this.changeFilters();
    },
      methods: {
        loadEmployer(employer_id){
            this.$refs.employeeModal.loadEmployer(employer_id);
        },
        async changeType (is_active) {
            this.is_active = is_active;

            this.changeFilters();
        },
        async changeFilters () {
            let flag = false;
            if(this.lastEmployer != this.employerSelect){
                flag = true;

                this.lastEmployer = this.employerSelect;
            }

            let filters = {
                employer_id: this.employerSelect,
                is_active: this.is_active ? 1 : 0
            };

            let response = await ws.getEmployeesFiltered(filters);

            if(response.type == "success"){
                this.employees = response.data;
            }
        },
        async exportEmployees() {
            let response = await ws.exportEmployees(this.employerSelect);

            if(response.type == "success"){
                this.$toast.success(response.message);

                window.open(response.data, '_blank');
            }
            else{
                this.$toast.error(response.message);
            }
        },
    },
    mixins: [getImage],
    computed: {
        ...mapState({
            card: (state) => state.common.usercard,
        }),
        filteredEmployees(){
            if(this.search == ''){
                return this.employees;
            }

            let query = this.search.toLowerCase();

            return this.employees.filter(item => item.name.toLowerCase().includes(query));
        }
    },
}

</script>

<style scoped>
    .project-cards {
        padding-top: 30px;
    }
</style>